// Bỏ qua tất cả các cảnh báo từ webpack
const originalConsoleWarn = console.warn;

console.warn = function filterWarnings(msg, ...args) {
  // Bỏ qua một số cảnh báo source map không quan trọng
  if (typeof msg === 'string' && 
      (msg.includes('Failed to parse source map'))) {
    return;
  }
  originalConsoleWarn(msg, ...args);
};